import React from "react";
import "./AboutUs.css";

const AboutUsMain = () => {
  return (
    <div className="aboutUsMainContainer">
      <p>
        At Goodway Attestation, we pride ourselves on being a leading expert in
        certificate attestation and apostille services. With 15+ years of
        experience and a team of dedicated professionals, we've earned a
        reputation for delivering fast, efficient, and reliable solutions.
      </p>
      <p>
        Our credentials speak for themselves: we're a REGISTERED and ISO
        9001:2015 certified company, recognized by the Government and various
        embassies. We specialize in attesting, authenticating, and legalizing
        all types of certificates, including educational and non-educational
        documents like marriage certificates, birth certificates, and
        affidavits.
      </p>
      <p>
        What sets us apart? We guarantee 100% genuine attestation on all
        certificates, and our competitive rates are unbeatable in the market.
        Trust us to handle your attestation needs with professionalism,
        precision, and a personalized touch. Let us take care of the paperwork,
        so you can focus on what matters most!
      </p>
    </div>
  );
};

export default AboutUsMain;
